export const staticCanonicalUrls = {
  SIGN_UP_BEING_HERD: "https://www.batyr.com.au/being-herd",
}
